import { HubLoanerPhoneListItem } from '../../../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../../../ui-kit';

export class HubLoanerPhoneItemLoad {
  public static readonly type = '[HubLoanerPhoneItem] Load Loaner Phone Item';

  constructor(public payload: { hubId: number; id: number }) {}
}

export class HubLoanerPhoneItemReturn {
  public static readonly type = '[HubLoanerPhoneItem] Return Loaner Phone Item';

  constructor(
    public payload: {
      dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>;
      hubId: number;
      id: number;
      returnTimestamp: number;
    },
  ) {}
}

export class HubLoanerPhoneItemCreate {
  public static readonly type = '[HubLoanerPhoneItem] Create Loaner Phone Item';

  constructor(public payload: { hubId: number; loanerPhoneItem: HubLoanerPhoneListItem }) {}
}

export class HubLoanerPhoneItemUpdate {
  public static readonly type = '[HubLoanerPhoneItem] Update Loaner Phone Item';

  constructor(public payload: { hubId: number; loanerPhoneItem: HubLoanerPhoneListItem }) {}
}

export class HubLoanerPhoneItemDelete {
  public static readonly type = '[HubLoanerPhoneItem] Delete Loaner Phone Item';

  constructor(
    public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>; hubId: number; id: number },
  ) {}
}

export class HubLoanerPhoneItemInitialState {
  public static readonly type = '[HubLoanerPhoneItem] Set Initial State';
}
